import { registerComponent } from '../app'

const LoadImage = (scope, el) => {
	el.classList.add('load-image')

	const onLoad = () => {
		el.classList.add('loaded')

		const event = new CustomEvent('imageLoad', {
			bubbles: true,
			cancelable: true
		})

		el.dispatchEvent(event)
	}

	const onLoadStart = () => {
		el.classList.remove('loaded')
	}

	setTimeout(() => {
		if (el.complete && el.naturalHeight !== 0) onLoad()
		el.addEventListener('load', onLoad)
		el.addEventListener('loadstart', onLoadStart)
	}, 250)
}

registerComponent('load-image', LoadImage)
